export const email = /^\S+@\S+\.\S+$/

export const requiredCity = "Merci d'indiquer votre ville"
export const requiredShop = "Merci d'indiquer le nom de votre magasin"
export const requiredNumber = "Merci d'indiquer votre numéro de téléphone"
export const requiredEmail = "Merci d'indiquer votre adresse mail"
export const invalidEmail = "Merci d'indiquer une adresse mail valide"
